// Author Lidongxu
// Date 2025-06-03 11:23:55

import * as model from "@/model/em/archive/EmStocktakingTaskDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmStocktakingTaskDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
    })
    .buildStore()
